import {
  PaperTypeMap,
  styled,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableRow as MuiTableRow,
} from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';

const TableContainer = styled(MuiTableContainer, {
  shouldForwardProp: (prop) => prop !== 'noBorders',
})<{
  component: OverridableComponent<PaperTypeMap>;
  noBorders?: boolean;
}>(({ theme, noBorders }) => ({
  border: noBorders ? 'none' : `1px solid ${theme.palette.grey[600]}`,
  boxShadow: 'none',
}));
const TableRow = styled(MuiTableRow, {
  shouldForwardProp: (prop) => prop !== 'noBorders',
})<{
  noBorders?: boolean;
}>(({ theme, noBorders }) => ({
  height: 40,
  '&:last-child > td': {
    borderBottom: noBorders ? `1px solid ${theme.palette.grey[600]}` : 'none',
  },
}));

const TableTitleCell = styled(MuiTableCell)(({ theme }) => ({
  backgroundColor: theme.palette.grey[500],
}));

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  borderBottomColor: theme.palette.grey[600],
  padding: '0px 16px',
}));
const FooterCell = styled(MuiTableCell)(({ theme }) => ({
  backgroundColor: theme.palette.grey[500],
  borderTop: `1px solid ${theme.palette.grey[600]}`,
  padding: 10,
  height: 60,
}));

export { TableContainer, TableCell, TableTitleCell, TableRow, FooterCell };
